import { ObjectContext } from '../../Components/OCV/OCVTypes'
import { BarCode, FixedTable, FormBanner, FormHeader, FormList, FormTable } from './formComponents'

export const PHIHeader = (props: {
    headerObj: any
    setDialogObject: (arg0: ObjectContext) => void
    setDialogVisible: (arg0: boolean) => void
}) => {
    const { headerObj, setDialogObject, setDialogVisible } = props
    return (
        <div id="PHIHeader" className="mt-0" style={{ paddingRight: '.8rem' }}>
            <div className="d-flex flex-row row pl-2">
                <FormHeader
                    lauoutObj={headerObj}
                    setDialogObject={setDialogObject}
                    setDialogVisible={setDialogVisible}
                />
            </div>
        </div>
    )
}
export const BarCodeSection = (props: { barCodeObj: any; bannerObj: any }) => {
    const { barCodeObj, bannerObj } = props
    return (
        <div id="barcode-middle" className="my-0">
            <div id="barcodeRow" className="row">
                <div id="barcode_div" className="col-6 printOnly">
                    <BarCode lauoutObj={barCodeObj} />
                </div>
                <div id="bannerText" className="col-6">
                    <FormBanner lauoutObj={bannerObj} />
                </div>
            </div>
        </div>
    )
}

export const ReadOnlyFormSection = (props: {
    centerTableList: any[]
    setDialogObject: (arg0: ObjectContext) => void
    setDialogVisible: (arg0: boolean) => void
}) => {
    const { centerTableList, setDialogObject, setDialogVisible } = props
    return (
        <div
            id="readOnlyFormSection"
            className="scroll-container scroll-fade col-12 p-0"
            style={{ minHeight: '150px', width: '98%' }}
        >
            <div>
                <div id="readOnlyScroll">
                    <div id="center_tables">
                        {centerTableList.map(
                            (
                                table: {
                                    type: string
                                    lauoutObj: any
                                    objectData: any
                                    j_index: any
                                    fixed: any
                                    collapsed: any
                                },
                                index: any
                            ) => {
                                const title = table.objectData.item0[table.j_index]?.t ?? ''
                                const component = table.lauoutObj.component
                                if (table.type == 'list') {
                                    return (
                                        <FormList
                                            component={component}
                                            title={title}
                                            j={table.j_index}
                                            index={index}
                                        />
                                    )
                                } else {
                                    if (table.fixed) {
                                        return (
                                            <FixedTable
                                                render={table.lauoutObj.render}
                                                component={component}
                                                title={title}
                                                j_index={table.j_index}
                                                index={index}
                                                setDialogObject={setDialogObject}
                                                setDialogVisible={setDialogVisible}
                                            />
                                        )
                                    } else {
                                        return (
                                            <FormTable
                                                render={table.lauoutObj.render}
                                                component={component}
                                                title={title}
                                                collapsed={table.collapsed}
                                                j_index={table.j_index}
                                                index={index}
                                                setDialogObject={setDialogObject}
                                                setDialogVisible={setDialogVisible}
                                            />
                                        )
                                    }
                                }
                            }
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
